module.exports = __webpack_public_path__ + "img/president-harry-s-truman.1cf62c38.png";